import VueRouter from 'vue-router';
import auth from '@/lib/auth/auth.admin';

export default function decorate(router: VueRouter) {
  router.beforeEach((to, from, next) => {
    document.title = `Elective ${!!to.meta && to.meta.title ? to.meta.title : ''}`;

    const isAuthenticated = auth.isAuthenticated();

    if (to.path.includes('/admin/app')) {
      if (isAuthenticated) {
        next();
      } else {
        const params = to.query;
        next({ path: '/admin/sign-in', query: { next: to.path, ...params } });
      }
    } else if (isAuthenticated && to.matched.map((m) => m.path).includes('/auth')) {
      next({ path: '/admin/app/projects' });
    } else next();
  });
}
